var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03347 19C2.40547 19 1.86789 18.7758 1.42074 18.3274C0.973579 17.879 0.75 17.3399 0.75 16.7102V12.8126H11.244C11.8718 12.8126 12.4093 12.5884 12.8564 12.14C13.3036 11.6916 13.5272 11.1527 13.5272 10.5231V0H22.4665C23.0945 0 23.6321 0.2242 24.0793 0.6726C24.5264 1.121 24.75 1.66007 24.75 2.28982V16.7102C24.75 17.3399 24.5264 17.879 24.0793 18.3274C23.6321 18.7758 23.0945 19 22.4665 19H3.03347ZM0.75 11.9969V4.82315C0.75 4.19341 0.973579 3.65433 1.42074 3.20593C1.86789 2.75753 2.40547 2.53333 3.03347 2.53333H10.1874L0.75 11.9969ZM4.50063 10.913L11.6327 3.76105V10.5231C11.6327 10.6367 11.5962 10.73 11.5232 10.8031C11.4503 10.8763 11.3573 10.913 11.244 10.913H4.50063Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.245654b165cba4e4e67f3d8f5d275e6c.svg";
export { ForwardRef as ReactComponent };